import { FC, useEffect, useState } from 'react'
import { nivelConsultorService } from '@/services/nivelConsultorService'
import { NivelResumido } from '@/types/nivelConsultor'
import { ChipNivel } from './ChipNivel'

/**
 * Nível do próprio consultor no cabeçalho do dashboard (AN-10 §10). Sem nível, carregando ou
 * com falha no `/meu`: não mostra nada — o dashboard nunca quebra por causa do nível
 * (Q-AN10-1). Tooltip com a descrição e o aviso "informativo".
 */
export const ChipMeuNivel: FC = () => {
  const [nivel, setNivel] = useState<NivelResumido | null>(null)

  useEffect(() => {
    let vivo = true
    const carregar = async () => {
      try {
        const n = await nivelConsultorService.meu()
        if (vivo) setNivel(n ?? null)
      } catch {
        if (vivo) setNivel(null)
      }
    }
    void carregar()
    return () => {
      vivo = false
    }
  }, [])

  if (!nivel) return null
  return <ChipNivel nome={nivel.nome} cor={nivel.cor} descricao={nivel.descricao} size="medium" />
}

export default ChipMeuNivel
